/**
 * Quiz Admin Layout
 */

import { Stack } from "expo-router";
import { useThemeColors } from "@/providers/ThemeProvider";

export default function QuizAdminLayout() {
  const colors = useThemeColors();

  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: colors.background },
        animation: "slide_from_right",
      }}
    >
      <Stack.Screen name="index" />
      <Stack.Screen name="create-quiz" />
      <Stack.Screen name="[id]/index" />
      <Stack.Screen name="[id]/questions" />
      <Stack.Screen 
        name="[id]/add-question" 
        options={{
          presentation: "modal",
          animation: "slide_from_bottom",
          gestureEnabled: false, // Prevent swipe to dismiss interfering with picker
        }}
      />
      <Stack.Screen name="[id]/question/[questionId]" />
      <Stack.Screen name="[id]/progress" />
      <Stack.Screen name="categories" />
    </Stack>
  );
}

